class CompareProductSlider {
  constructor(container) {
    this.container = container;
    this.table = this.container.querySelector('.compare__table');
    this.products = Array.from(this.container.querySelectorAll('.compare__product'));
    this.cells = Array.from(this.container.querySelectorAll('.compare-table__cell[data-product-index]'));

    this.leftButton = this.container.querySelector('#scroll-left');
    this.rightButton = this.container.querySelector('#scroll-right');
    this.leftButtonMobile = this.container.querySelector('#scroll-left-mobile');
    this.rightButtonMobile = this.container.querySelector('#scroll-right-mobile');
    this.productNameMobile = this.container.querySelector('#product-name-mobile');

    this.currentIndex = 0;
    this.totalProducts = this.products.length;
    this.visibleCount = this.getVisibleCount();
    this.bound = false;

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.minSwipeDistance = 50;
  }

  getVisibleCount() {
    const width = window.innerWidth;
    if (width <= 767) return 1;
    if (width <= 989) return 2;
    return 3;
  }

  initialize() {
    if (!this.table || this.totalProducts === 0) return;

    this.visibleCount = this.getVisibleCount();
    this.currentIndex = Math.min(this.currentIndex, Math.max(0, this.totalProducts - this.visibleCount));

    if (this.totalProducts <= 1) {
      this.showAllProducts();
      this.toggleButtons(false);
      this.hideMobileControls();
      return;
    }

    if (this.totalProducts <= 3 && window.innerWidth > 767) {
      this.showAllProducts();
      this.toggleButtons(false);
      this.hideMobileControls();
      return;
    }

    this.updateVisibility();
    this.updateButtons();
    this.updateProductName();
    this.updateMobileControlsVisibility();

    if (!this.bound) {
      this.bindEvents();
      this.bound = true;
    }
  }

  bindEvents() {
    const bindClick = (button, handler) => {
      if (button) button.addEventListener('click', handler);
    };

    bindClick(this.leftButton, () => this.scrollLeft());
    bindClick(this.rightButton, () => this.scrollRight());
    bindClick(this.leftButtonMobile, () => this.scrollLeft());
    bindClick(this.rightButtonMobile, () => this.scrollRight());

    if (this.table) {
      this.table.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
      this.table.addEventListener('touchmove', (event) => this.handleTouchMove(event), { passive: true });
      this.table.addEventListener('touchend', () => this.handleTouchEnd(), { passive: true });
    }
  }

  showAllProducts() {
    this.products.forEach((el) => (el.style.display = 'table-cell'));
    this.cells.forEach((el) => (el.style.display = 'table-cell'));
    this.updateProductName();
  }

  toggleButtons(show) {
    const isMobile = window.innerWidth <= 767;
    const desktopButtons = [this.leftButton, this.rightButton];
    const mobileButtons = [this.leftButtonMobile, this.rightButtonMobile];

    desktopButtons.forEach((button) => {
      if (!button) return;
      button.style.display = show && !isMobile ? '' : 'none';
    });

    mobileButtons.forEach((button) => {
      if (!button) return;
      button.style.display = show && isMobile ? 'flex' : 'none';
    });
  }

  hideMobileControls() {
    [this.leftButtonMobile, this.rightButtonMobile].forEach((button) => {
      if (button) button.style.display = 'none';
    });
    if (this.productNameMobile) this.productNameMobile.style.display = 'none';
  }

  updateMobileControlsVisibility() {
    const isMobile = window.innerWidth <= 767;
    if (this.productNameMobile) this.productNameMobile.style.display = isMobile ? 'block' : 'none';
  }

  updateVisibility() {
    const isVisible = (index) => index >= this.currentIndex && index < this.currentIndex + this.visibleCount;

    this.products.forEach((product) => {
      const index = Number(product.dataset.productIndex);
      product.style.display = isVisible(index) ? 'table-cell' : 'none';
    });

    this.cells.forEach((cell) => {
      const index = Number(cell.dataset.productIndex);
      cell.style.display = isVisible(index) ? 'table-cell' : 'none';
    });
  }

  updateButtons() {
    const showControls = this.totalProducts > this.visibleCount;
    this.toggleButtons(showControls);

    const maxIndex = Math.max(0, this.totalProducts - this.visibleCount);
    const atStart = this.currentIndex <= 0;
    const atEnd = this.currentIndex >= maxIndex;

    [this.leftButton, this.leftButtonMobile].forEach((button) => {
      if (button) button.disabled = atStart;
    });

    [this.rightButton, this.rightButtonMobile].forEach((button) => {
      if (button) button.disabled = atEnd;
    });
  }

  updateProductName() {
    if (!this.productNameMobile || window.innerWidth > 767) {
      if (this.productNameMobile) this.productNameMobile.textContent = '';
      return;
    }

    const activeProduct = this.products.find(
      (product) => Number(product.dataset.productIndex) === this.currentIndex
    );

    this.productNameMobile.textContent =
      activeProduct?.dataset.productShortName ||
      activeProduct?.dataset.productTitle ||
      activeProduct?.querySelector('img')?.alt ||
      '';
  }

  scrollLeft() {
    if (this.currentIndex <= 0) return;
    this.currentIndex -= 1;
    this.updateVisibility();
    this.updateButtons();
    this.updateProductName();
  }

  scrollRight() {
    const maxIndex = this.totalProducts - this.visibleCount;
    if (this.currentIndex >= maxIndex) return;
    this.currentIndex += 1;
    this.updateVisibility();
    this.updateButtons();
    this.updateProductName();
  }

  handleTouchStart(event) {
    if (window.innerWidth > 767) return;
    const touch = event.touches[0];
    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
  }

  handleTouchMove(event) {
    if (window.innerWidth > 767) return;
    const touch = event.touches[0];
    this.touchEndX = touch.clientX;
    this.touchEndY = touch.clientY;
  }

  handleTouchEnd() {
    if (window.innerWidth > 767 || !this.touchStartX) return;

    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance;

    if (isHorizontalSwipe) {
      if (deltaX < 0) this.scrollRight();
      else this.scrollLeft();
    }

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
  }
}

(() => {
  const instances = [];

  const getInstance = (container) => instances.find((item) => item.container === container);

  const initCompareTables = () => {
    document.querySelectorAll('.compare').forEach((container) => {
      let instance = getInstance(container);
      if (!instance) {
        instance = new CompareProductSlider(container);
        instances.push(instance);
      }
      instance.initialize();
    });
  };

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initCompareTables();
    }, 120);
  });

  document.addEventListener('compare:modal-opened', () => {
    // Wait one frame so layout dimensions are available after modal animation starts.
    requestAnimationFrame(() => initCompareTables());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompareTables);
  } else {
    initCompareTables();
  }
})();

